/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
import {PageTitle} from '../../../../_metronic/layout/core'
import {PricingTableListWrapper} from './components/PricingTableList/PricingTableList'

const PricingTablesWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'PRODUCTS.TITLE'})}</PageTitle>
      <AnimaFadeinTop>
        <PricingTableListWrapper />
        <br />
      </AnimaFadeinTop>
    </>
  )
}
export {PricingTablesWrapper}
